export const TimerProgression = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const

export type TimerProgression = (typeof TimerProgression)[keyof typeof TimerProgression]
